import { render, staticRenderFns } from "./moonPhase.vue?vue&type=template&id=61ec3390&"
import script from "./moonPhase.vue?vue&type=script&lang=js&"
export * from "./moonPhase.vue?vue&type=script&lang=js&"
import style0 from "./moonPhase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports